import { Checkbox } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/16/solid";

interface IToggleProps {
  enabled: boolean;
  setEnabled: any;
  disabled?: boolean;
}

export function UiCheckbox({ enabled, setEnabled, disabled }: IToggleProps) {
  return (
    <div className="flex items-center gap-2 z-30">
      <Checkbox
        disabled={disabled}
        checked={enabled}
        onChange={setEnabled}
        className="group size-4 rounded-md ring-1 ring-gray ring-inset flex items-center justify-center
         data-[checked]:bg-primary data-[checked]:ring-primary cursor-pointer 
         data-[disabled]:cursor-not-allowed data-[disabled]:bg-extraLightGray/30"
      >
        <CheckIcon className="hidden fill-white group-data-[checked]:block" />
      </Checkbox>
    </div>
  );
}

export const UiCheckboxBase = ({ enabled, setEnabled }: IToggleProps) => {
  return (
    <>
      <label
        htmlFor="head_check"
        data-checked={enabled}
        className="group size-5 rounded-md ring-1 ring-gray ring-inset flex items-center justify-center
         data-[checked=true]:bg-primary data-[checked=true]:ring-primary cursor-pointer "
      >
        <CheckIcon className="hidden fill-white group-data-[checked=true]:block" />
      </label>
      <input
        id="head_check"
        type="checkbox"
        checked={enabled}
        onChange={setEnabled}
        className="border-transparent hidden"
      />
    </>
  );
};
